import { render, staticRenderFns } from "./Management.vue?vue&type=template&id=0493f174&"
import script from "./Management.vue?vue&type=script&lang=ts&"
export * from "./Management.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0493f174')) {
      api.createRecord('0493f174', component.options)
    } else {
      api.reload('0493f174', component.options)
    }
    module.hot.accept("./Management.vue?vue&type=template&id=0493f174&", function () {
      api.rerender('0493f174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/Management.vue"
export default component.exports